
    <template>
      <section class="doc-article monkey-view-doc">
        <h1>Upload 上传</h1>
<p>通过点击或拖拽上传文件的控件。</p>
<p>上传是将文件资源通过网页上传到指定服务器的过程。当需要上传一个或者多个文件你需要用到。</p>
<h2 id="dai-ma-shi-li" class="anchor-title">代码示例 <a class="header-anchor" href="#dai-ma-shi-li">#</a></h2>
<code-wrap id="DJSC">
                <template slot="description"><p>点击上传，一次选择一个文件。</p>
<p>设置<code>action</code>属性定义上传地址。</p>
<p>设置<code>accept</code>属性限定选择文件类型，此属性为原生属性，只是选择文件时显示选择文件的类型，但是依然可以上传别的类型的文件。此时可以添加<code>format</code>属性限定上传文件的类型。</p>
<p>设置<code>maxSize</code>属性限制上传文件的大小，单位kb。</p>
<p><code>onExceed</code>属性是一个方法，超出限制时触发，超出大小限制和文件类型限制和数量限制时都会触发，参数为type当前限制类型，file当前上传文件，fileList文件列表。其中<code>type</code>值为<code>size</code>(超出大小限制),<code>type</code>(超出文件类型限制),<code>limit</code>(超出文件数量限制)。</p>
</template>
                <template slot="title">点击上传 <a href="#DJSC" data-title="点击上传">#</a></template>
                <template slot="source"><monkey-view-demo0 /></template>
                <template slot="highlight">
<p></p>
<p></p>
<p></p>
<p></p>
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Upload action=&quot;//jsonplaceholder.typicode.com/posts/&quot; accept=&quot;.jpg,.png&quot; :format=&quot;['jpg', 'png']&quot; :maxSize=&quot;500&quot; :limit=&quot;5&quot; :onExceed=&quot;exceedHandler&quot;&gt;
        &lt;Button&gt;upload&lt;/Button&gt;
        &lt;div slot=&quot;tip&quot; class=&quot;Upload__tip&quot;&gt;只能上传jpg/png文件，大小不能超过500kb&lt;/div&gt;
    &lt;/Upload&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          
        }
      },
      methods: {
        exceedHandler(type, file, fileList){
          let info = '';
          switch (type) {
            case 'limit': 
                info = '上传文件数量超出限制5个';
              break;
            case 'type': 
                info = '上传文件类型不正确，请上传jpg/png文件';
              break;
            case 'size': 
                info = '上传文件大小超过500kb，请重新上传';
              break;
          }
          this.$Message.error(info);
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="DX">
                <template slot="description"><p>多选点击上传，一次可以选择多个文件，设置<code>multiple</code>属性实现多选上传。</p>
</template>
                <template slot="title">多选 <a href="#DX" data-title="多选">#</a></template>
                <template slot="source"><monkey-view-demo1 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Upload action=&quot;//jsonplaceholder.typicode.com/posts/&quot; multiple&gt;
        &lt;Button&gt;upload&lt;/Button&gt;
        &lt;div slot=&quot;tip&quot; class=&quot;Upload__tip&quot;&gt;可以一次选择多个文件上传&lt;/div&gt;
    &lt;/Upload&gt;
&lt;/template&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="SDSC">
                <template slot="description"><p>绑定<code>before-upload</code>并返回<code>false</code>，阻止默认的上传流程，可以自己手动控制上传。绑定<code>fileList</code>手动控制上传列表。</p>
</template>
                <template slot="title">手动上传 <a href="#SDSC" data-title="手动上传">#</a></template>
                <template slot="source"><monkey-view-demo2 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Upload action=&quot;//jsonplaceholder.typicode.com/posts/&quot; 
    :file-list=&quot;fileList&quot; :before-upload=&quot;beforeUploadHandler&quot;&gt;
        &lt;Button&gt;select file&lt;/Button&gt;
    &lt;/Upload&gt;
    &lt;Button type=&quot;primary&quot; :disabled=&quot;!fileList.length&quot; :loading=&quot;loading&quot; @click=&quot;clickHandler&quot;&gt;click upload file&lt;/Button&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          fileList: [],
          loading: false,
        }
      },
      methods: {
        beforeUploadHandler(file){
          console.log(file,'file')
          this.fileList.push(file);
          return false;
        },
        clickHandler(){
          this.loading = true;
          setTimeout(()=&gt;{
            this.fileList = [];
            this.loading = false;
            this.$Message.success('上传成功')
          }, 2000)
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="TZSC">
                <template slot="description"><p>设置<code>drag</code>属性实现拖拽上传。</p>
</template>
                <template slot="title">拖拽上传 <a href="#TZSC" data-title="拖拽上传">#</a></template>
                <template slot="source"><monkey-view-demo3 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Upload action=&quot;//jsonplaceholder.typicode.com/posts/&quot; drag&gt;
        &lt;Icon type=&quot;cloud-upload&quot; style=&quot;color: #2d8cf0;&quot;&gt;&lt;/Icon&gt;
        &lt;div class=&quot;doc-upload-title&quot;&gt;drag upload file&lt;/div&gt;
    &lt;/Upload&gt;
&lt;/template&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="ZPQ">
                <template slot="description"><p>设置<code>listType=picture-card</code>实现照片墙展示上传列表。</p>
</template>
                <template slot="title">照片墙 <a href="#ZPQ" data-title="照片墙">#</a></template>
                <template slot="source"><monkey-view-demo4 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Upload action=&quot;//jsonplaceholder.typicode.com/posts/&quot; 
    drag 
    listType=&quot;picture-card&quot; 
    :file-list=&quot;fileListPictureCard&quot; 
    :onPreview=&quot;handlerPreview&quot; 
    :onRemove=&quot;handlerRemove&quot; 
    :onSuccess=&quot;handlerSuccess&quot;&gt;
        &lt;Icon type=&quot;plus&quot;&gt;&lt;/Icon&gt;
        &lt;div&gt;上传文件&lt;/div&gt;
    &lt;/Upload&gt;
    &lt;Modal v-model=&quot;modalVisible&quot; footer-hide&gt;
        &lt;img :src=&quot;modalFile.url&quot; width=&quot;100%&quot; alt=&quot;&quot; /&gt;
    &lt;/Modal&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          fileListPictureCard: [
            {
              name: 'XXX1.jpg',
              url: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=655054976,1593018610&amp;fm=26&amp;gp=0.jpg'
            },
            {
              name: 'XXX2.jpg',
              url: 'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2496520483,2043298183&amp;fm=26&amp;gp=0.jpg'
            }
          ],
          modalFile: {},
          modalVisible: false,
        }
      },
      methods: {
        handlerPreview(file) {
            this.modalFile = file;
            this.modalVisible = true;
        },
        handlerRemove(file, fileList){
          this.fileListPictureCard = fileList;
          this.$Message.info('删除成功');
        },
        handlerSuccess(res, file, fileList){
          this.fileListPictureCard.push(file);
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="TBLB">
                <template slot="description"><p>设置<code>listType=picture</code>实现照片墙展示上传列表。</p>
</template>
                <template slot="title">图标列表 <a href="#TBLB" data-title="图标列表">#</a></template>
                <template slot="source"><monkey-view-demo5 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Upload action=&quot;//jsonplaceholder.typicode.com/posts/&quot; 
    listType=&quot;picture&quot; 
    :file-list=&quot;fileListPicture&quot; 
    :onRemove=&quot;handlerRemove&quot; 
    :onSuccess=&quot;handlerSuccess&quot;&gt;
        &lt;Button&gt;upload&lt;/Button&gt;
    &lt;/Upload&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          fileListPicture: [
            {
              name: 'XXX1.jpg',
              url: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=655054976,1593018610&amp;fm=26&amp;gp=0.jpg'
            },
            {
              name: 'XXX2.jpg',
              url: 'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2496520483,2043298183&amp;fm=26&amp;gp=0.jpg'
            }
          ],
        }
      },
      methods: {
        handlerRemove(file, fileList){
          this.fileListPicture = fileList;
          this.$Message.info('删除成功');
        },
        handlerSuccess(res, file, fileList){
          this.fileListPicture.push(file);
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<h2 id="api" class="anchor-title">API <a class="header-anchor" href="#api">#</a></h2>
<h3 id="upload-props" class="anchor-title">Upload props <a class="header-anchor" href="#upload-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td>String</td>
<td>上传文件的字段名</td>
<td>file</td>
</tr>
<tr>
<td>action</td>
<td>String</td>
<td>上传的地址</td>
<td>-</td>
</tr>
<tr>
<td>listType</td>
<td>String</td>
<td>可选值<code>text</code> <code>picture</code> <code>picture-card</code>。上传列表的样式</td>
<td>text</td>
</tr>
<tr>
<td>fileList</td>
<td>Array</td>
<td>自己控制上传文件列表。设置fileList的格式为<code>[{name: 'name', url: ''}]</code></td>
<td>[]</td>
</tr>
<tr>
<td>drag</td>
<td>Boolean</td>
<td>开启拖拽上传</td>
<td>-</td>
</tr>
<tr>
<td>multiple</td>
<td>Boolean</td>
<td>多选</td>
<td>-</td>
</tr>
<tr>
<td>accept</td>
<td>String</td>
<td>原生属性，指定选择文件格式，详见 <a href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-accept" target="_blank">文件类型</a></td>
<td>-</td>
</tr>
<tr>
<td>format</td>
<td>Array</td>
<td>支持的文件格式，与accept不同的是，accept是原生属性，会在选择文件时过滤，但是不会强制限制文件格式。此选项可以和accept配合使用，也可以单独使用，限制上传文件的格式。值类型如：<code>['jpg','png']</code>,此时上传别的格式文件时不会执行接口请求</td>
<td>[]]</td>
</tr>
<tr>
<td>showUploadList</td>
<td>Boolean</td>
<td>是否显示文件列表</td>
<td>true</td>
</tr>
<tr>
<td>limit</td>
<td>Number</td>
<td>限制上传数量</td>
<td>-</td>
</tr>
<tr>
<td>maxSize</td>
<td>Number</td>
<td>限制上传文件的大小。默认单位KB</td>
<td>-</td>
</tr>
<tr>
<td>disabled</td>
<td>Boolean</td>
<td>禁用选项</td>
<td>-</td>
</tr>
<tr>
<td>headers</td>
<td>Object</td>
<td>设置上传的请求头部</td>
<td>-</td>
</tr>
<tr>
<td>data</td>
<td>Object</td>
<td>上传时附带的额外参数</td>
<td>-</td>
</tr>
<tr>
<td>beforeUpload</td>
<td>Function(file)</td>
<td>上传之前的钩子函数。参数为当前上传的文件，若返回false或者Promise则停止上传</td>
<td>-</td>
</tr>
<tr>
<td>onChange</td>
<td>Function(file, fileList)</td>
<td>上传文件改变时的状态。添加文件、上传成功、上传失败都会调用</td>
<td>-</td>
</tr>
<tr>
<td>onProgress</td>
<td>Function(event, file, fileList)</td>
<td>上传时的钩子</td>
<td>-</td>
</tr>
<tr>
<td>onSuccess</td>
<td>Function(response, file, fileList)</td>
<td>上传成功的钩子</td>
<td>-</td>
</tr>
<tr>
<td>onError</td>
<td>Function(error, file, fileList)</td>
<td>上传失败的钩子</td>
<td>-</td>
</tr>
<tr>
<td>onRemove</td>
<td>Function(file, fileList)</td>
<td>文件列表移出的钩子</td>
<td>-</td>
</tr>
<tr>
<td>onPreview</td>
<td>Function(file)</td>
<td>点击文件列表中已上传文件的钩子</td>
<td>-</td>
</tr>
<tr>
<td>onExceed</td>
<td>Function(type, file, fileList)</td>
<td>文件超出限制时的钩子,<code>type</code>值为<code>limit</code>(超出文件数量限制) <code>size</code>(超出文件大小限制) <code>type</code>(超出文件类型限制)</td>
<td>-</td>
</tr>
</tbody>
</table>
<h3 id="upload-slot" class="anchor-title">Upload slot <a class="header-anchor" href="#upload-slot">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>-</td>
<td>触发上传组件的控件</td>
</tr>
<tr>
<td>tip</td>
<td>辅助提示内容</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "monkey-view-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Upload',{attrs:{"action":"//jsonplaceholder.typicode.com/posts/","accept":".jpg,.png","format":['jpg', 'png'],"maxSize":500,"limit":5,"onExceed":_vm.exceedHandler}},[_c('Button',[_vm._v("upload")]),_vm._v(" "),_c('div',{staticClass:"Upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传jpg/png文件，大小不能超过500kb")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          
        }
      },
      methods: {
        exceedHandler(type, file, fileList){
          let info = '';
          switch (type) {
            case 'limit': 
                info = '上传文件数量超出限制5个';
              break;
            case 'type': 
                info = '上传文件类型不正确，请上传jpg/png文件';
              break;
            case 'size': 
                info = '上传文件大小超过500kb，请重新上传';
              break;
          }
          this.$Message.error(info);
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Upload',{attrs:{"action":"//jsonplaceholder.typicode.com/posts/","multiple":""}},[_c('Button',[_vm._v("upload")]),_vm._v(" "),_c('div',{staticClass:"Upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("可以一次选择多个文件上传")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Upload',{attrs:{"action":"//jsonplaceholder.typicode.com/posts/","file-list":_vm.fileList,"before-upload":_vm.beforeUploadHandler}},[_c('Button',[_vm._v("select file")])],1),_vm._v(" "),_c('Button',{attrs:{"type":"primary","disabled":!_vm.fileList.length,"loading":_vm.loading},on:{"click":_vm.clickHandler}},[_vm._v("click upload file")])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          fileList: [],
          loading: false,
        }
      },
      methods: {
        beforeUploadHandler(file){
          console.log(file,'file')
          this.fileList.push(file);
          return false;
        },
        clickHandler(){
          this.loading = true;
          setTimeout(()=>{
            this.fileList = [];
            this.loading = false;
            this.$Message.success('上传成功')
          }, 2000)
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Upload',{attrs:{"action":"//jsonplaceholder.typicode.com/posts/","drag":""}},[_c('Icon',{staticStyle:{"color":"#2d8cf0"},attrs:{"type":"cloud-upload"}}),_vm._v(" "),_c('div',{staticClass:"doc-upload-title"},[_vm._v("drag upload file")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo4": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Upload',{attrs:{"action":"//jsonplaceholder.typicode.com/posts/","drag":"","listType":"picture-card","file-list":_vm.fileListPictureCard,"onPreview":_vm.handlerPreview,"onRemove":_vm.handlerRemove,"onSuccess":_vm.handlerSuccess}},[_c('Icon',{attrs:{"type":"plus"}}),_vm._v(" "),_c('div',[_vm._v("上传文件")])],1),_vm._v(" "),_c('Modal',{attrs:{"footer-hide":""},model:{value:(_vm.modalVisible),callback:function ($$v) {_vm.modalVisible=$$v},expression:"modalVisible"}},[_c('img',{attrs:{"src":_vm.modalFile.url,"width":"100%","alt":""}})])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          fileListPictureCard: [
            {
              name: 'XXX1.jpg',
              url: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=655054976,1593018610&fm=26&gp=0.jpg'
            },
            {
              name: 'XXX2.jpg',
              url: 'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2496520483,2043298183&fm=26&gp=0.jpg'
            }
          ],
          modalFile: {},
          modalVisible: false,
        }
      },
      methods: {
        handlerPreview(file) {
            this.modalFile = file;
            this.modalVisible = true;
        },
        handlerRemove(file, fileList){
          this.fileListPictureCard = fileList;
          this.$Message.info('删除成功');
        },
        handlerSuccess(res, file, fileList){
          this.fileListPictureCard.push(file);
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo5": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Upload',{attrs:{"action":"//jsonplaceholder.typicode.com/posts/","listType":"picture","file-list":_vm.fileListPicture,"onRemove":_vm.handlerRemove,"onSuccess":_vm.handlerSuccess}},[_c('Button',[_vm._v("upload")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          fileListPicture: [
            {
              name: 'XXX1.jpg',
              url: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=655054976,1593018610&fm=26&gp=0.jpg'
            },
            {
              name: 'XXX2.jpg',
              url: 'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2496520483,2043298183&fm=26&gp=0.jpg'
            }
          ],
        }
      },
      methods: {
        handlerRemove(file, fileList){
          this.fileListPicture = fileList;
          this.$Message.info('删除成功');
        },
        handlerSuccess(res, file, fileList){
          this.fileListPicture.push(file);
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  